import { useApiPrivateRequest } from "@/shared/hooks/useApi";
import { PlaybooksSettings } from "../models/PlaybooksSettings";

export const useGetPlaybooksSettings = () => {
  const {
    data: playbooksSettings,
    call,
    setData: setPlaybooksSettings,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<PlaybooksSettings>(
    (response) => new PlaybooksSettings(response),
  );

  const getPlaybooksSettings = async () => {
    await call("/playbooks/settings", "GET");
  };

  return {
    playbooksSettings,
    getPlaybooksSettings,
    setPlaybooksSettings,
    isLoading,
    isFailed,
  };
};
